import { create } from 'zustand'

/**
 * Order-feed selection. Past-order items (`sourceType: ONLINE`) already exist on Core as
 * Potentials, but they're candidates — the customer taps which ones to actually trade in. That
 * choice is client-side (like v1's cart), keyed by potential `_id`. Manually-added items
 * (search / photo) are always in the basket and are NOT tracked here.
 */
interface SelectionState {
  selected: Record<string, true>
  toggle: (id: string) => void
  deselect: (id: string) => void
  clear: () => void
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selected: {},
  toggle: (id) =>
    set((s) => {
      const next = { ...s.selected }
      if (next[id]) delete next[id]
      else next[id] = true
      return { selected: next }
    }),
  deselect: (id) =>
    set((s) => {
      if (!s.selected[id]) return s
      const next = { ...s.selected }
      delete next[id]
      return { selected: next }
    }),
  clear: () => set({ selected: {} }),
}))
